__turbopack_context__.v({
  "close": "Overlay-module__2qq74a__close",
  "closeIcon": "Overlay-module__2qq74a__closeIcon",
  "container": "Overlay-module__2qq74a__container",
  "fadeInItems": "Overlay-module__2qq74a__fadeInItems",
  "spacing--lg": "Overlay-module__2qq74a__spacing--lg",
  "spacing--md": "Overlay-module__2qq74a__spacing--md",
  "spacing--sm": "Overlay-module__2qq74a__spacing--sm",
  "spacing--xl": "Overlay-module__2qq74a__spacing--xl",
  "spacing--xs": "Overlay-module__2qq74a__spacing--xs",
  "spacing--xxl": "Overlay-module__2qq74a__spacing--xxl",
  "spacing--xxs": "Overlay-module__2qq74a__spacing--xxs",
  "spacing--xxxl": "Overlay-module__2qq74a__spacing--xxxl",
  "spacing--xxxs": "Overlay-module__2qq74a__spacing--xxxs",
  "transparent": "Overlay-module__2qq74a__transparent",
});
